import type { ShellThemeInfo } from '@1js/suiteux-shell-react';
import { setItem } from '@ms/yammer-libs-local-storage';
import { reportInfo } from '@ms/yammer-telemetry';

import type { SuiteHeaderThemeAction } from './actions.types';

const type = 'SUITE_HEADER_THEME.UPDATED';

type ReportThemeUpdate = (isDarkMode: boolean) => void;
const reportThemeUpdate: ReportThemeUpdate = (isDarkMode) => {
  reportInfo({
    eventName: 'theme_updated',
    eventProperties: {
      isDarkMode,
    },
  });
};

type ThemeUpdated = (theme: ShellThemeInfo) => SuiteHeaderThemeAction;
export const themeUpdated: ThemeUpdated = (theme) => {
  const isAppTheme = theme.ThemeType === 'App';
  const isTenantTheme = theme.ThemeId === 'base';
  const isInverted = theme.IsDarkMode;

  reportThemeUpdate(isInverted);
  setItem('yammer.splash.isInverted', isInverted);

  // The suite header does not yet support an inverted tenant theme, so we use our default theme instead
  const isDefault = isAppTheme || (isInverted && isTenantTheme);

  return {
    type,
    payload: {
      colors: {
        themeDarker: theme.Darker,
        themeDark: theme.Dark,
        themeDarkAlt: theme.DarkAlt,
        themePrimary: theme.Primary,
        themeSecondary: theme.Secondary,
        themeTertiary: theme.Tertiary,
        themeLight: theme.Light,
        themeLighter: theme.Lighter,
        themeLighterAlt: theme.LighterAlt,
      },
      isInverted,
      isDefault,
      id: theme.ThemeId,
      type: theme.ThemeType,
    },
  };
};

export const configureThemeIsDefault: () => SuiteHeaderThemeAction = () => ({
  type,
  payload: {
    isDefault: true,
  },
});
